import { buildBaseOverrides } from 'Components/UI/guidedHouseholdReview/baseOverrides';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { FDHeadlineText } from '@facet-wealth/design';
import { BigPicklistInput } from 'Packages/FacetDesign/Components';
import { Disclosure } from 'Organisms/Disclosure/Disclosure';

export const metaOverrideSet = buildBaseOverrides()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'lg' },
  }, overrideReadOnly)
  .nameOverride('accounts', {
    _component: () => BigPicklistInput,
  }, overrideReadOnly)
  .nameOverride('disclosure', {
    _component: () => Disclosure,
    _customProps: { disablePadding: true },
  }, overrideReadOnly);
